import { useEffect, useState } from 'react';
import { normaliseHexColour } from 'src/secret-menu/brand-asset-builder/lib/hexColour';

// Single-field counterpart to `usePaletteColourDrafts` - same draft-then-commit-on-blur reasoning
// (see that hook's own comment), just for a standalone hex field that isn't part of the palette.
export function useHexColourDraft(committed: string, onCommit: (value: string) => void) {
  const [draft, setDraft] = useState(committed);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (!isFocused) {
      setDraft(committed);
    }
  }, [committed, isFocused]);

  const handleFocus = () => setIsFocused(true);

  const handleBlur = () => {
    setIsFocused(false);
    const normalised = normaliseHexColour(draft);
    if (normalised === null) {
      setDraft(committed);
      return;
    }
    setDraft(normalised);
    if (normalised !== committed) {
      onCommit(normalised);
    }
  };

  return { draft, setDraft, handleFocus, handleBlur };
}
